export const getWatermarkLotIdFromUrl = (
  watermarkedUrl: string | null,
): string | null =>
  watermarkedUrl?.match(/\/watermarked\/([^/?#]+)\//)?.[1] ?? null;

type WatermarkLot = {
  id: string;
  watermark_enabled: boolean;
};

export const findWatermarkLotForRegeneration = (
  lots: readonly WatermarkLot[],
  lotId: string | null | undefined,
  previousWatermarkedUrl: string | null,
): WatermarkLot | undefined => {
  const previousWatermarkLotId = getWatermarkLotIdFromUrl(
    previousWatermarkedUrl,
  );

  return (
    lots.find(lot => lot.id === lotId && lot.watermark_enabled) ??
    lots.find(lot => lot.id === previousWatermarkLotId && lot.watermark_enabled)
  );
};
